// Storage keys
export const STORAGE_KEY = "orderflow_column_widths";
export const COLUMN_ORDER_KEY = "orderflow_column_order";
export const MODIFIED_ROWS_KEY = "orderflow_modified_rows";

// Table dimensions
export const DEFAULT_WIDTH = 150;
export const MIN_WIDTH = 60;
export const HIGHLIGHT_DURATION_MS = 60 * 60 * 1000; // 1 hour

// Column name migrations (for backwards compatibility)
export const COLUMN_NAME_MIGRATIONS = {
  "TYPE REGLT.": "PAYMENT METHOD",
  "TYPE_REGLT.": "PAYMENT METHOD",
  "type_reglt.": "PAYMENT METHOD",
};

// Filter operators
export const FILTER_OPERATORS = [
  { value: 'contains', label: 'Contient', types: ['text', 'dropdown'] },
  { value: 'not_contains', label: 'Ne contient pas', types: ['text', 'dropdown'] },
  { value: 'equals', label: 'Égal à', types: ['text', 'dropdown', 'status', 'checkbox', 'amount', 'percentage', 'numerique'] },
  { value: 'not_equals', label: 'Différent de', types: ['text', 'dropdown', 'status', 'checkbox', 'amount', 'percentage', 'numerique'] },
  { value: 'starts_with', label: 'Commence par', types: ['text'] },
  { value: 'ends_with', label: 'Termine par', types: ['text'] },
  { value: 'is_empty', label: 'Est vide', types: ['text', 'dropdown', 'date', 'amount', 'percentage', 'numerique', 'phone'] },
  { value: 'is_not_empty', label: 'N\'est pas vide', types: ['text', 'dropdown', 'date', 'amount', 'percentage', 'numerique', 'phone'] },
  { value: 'greater_than', label: 'Supérieur à', types: ['amount', 'percentage', 'numerique'] },
  { value: 'less_than', label: 'Inférieur à', types: ['amount', 'percentage', 'numerique'] },
  { value: 'between', label: 'Entre', types: ['amount', 'percentage', 'numerique'] },
  { value: 'date_equals', label: 'Date égale à', types: ['date'] },
  { value: 'date_before', label: 'Avant le', types: ['date'] },
  { value: 'date_after', label: 'Après le', types: ['date'] },
  { value: 'date_between', label: 'Entre les dates', types: ['date'] },
];

// Column types configuration
export const COLUMN_TYPES = [
  { value: 'text', label: 'Texte', icon: 'Type' },
  { value: 'checkbox', label: 'Case à cocher', icon: 'Check' },
  { value: 'date', label: 'Date', icon: 'Calendar' },
  { value: 'dropdown', label: 'Liste déroulante', icon: 'List' },
  { value: 'status', label: 'Feu tricolore', icon: 'Circle' },
  { value: 'amount', label: 'Montant €', icon: 'Euro' },
  { value: 'percentage', label: 'Pourcentage %', icon: 'Percent' },
  { value: 'numerique', label: 'Numérique', icon: 'Hash' },
  { value: 'phone', label: 'Téléphone', icon: 'Phone' },
  { value: 'calcul', label: 'Calcul', icon: 'Calculator' },
  { value: 'fabric', label: 'Vignette toile', icon: 'Image' },
];

// Status colors
export const STATUS_COLORS = [
  { key: 'green', color: 'bg-green-500', label: 'Vert' },
  { key: 'orange', color: 'bg-orange-500', label: 'Orange' },
  { key: 'red', color: 'bg-red-500', label: 'Rouge' },
];
